import { Grid } from '@mui/material';
import { FormNotasCredito, ListaNotasCredito } from '../../components/notasCreditos';

export const NotasCredito = () => (
  <Grid sx={{ marginTop: 1 }} container spacing={2}>
    <FormNotasCredito />
    <ListaNotasCredito />
  </Grid>
);
